"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.itemStyles = exports.imageStyles = exports.gridStyles = void 0;
var _constants = require("../../constants");
const gridStyles = (theme)=>({
        alignItems: 'end',
        display: 'grid',
        gap: theme.spacing(3),
        gridTemplateColumns: "repeat(auto-fill, ".concat(_constants.ITEM_WIDTH, "px)"),
        justifyContent: 'space-around',
        padding: theme.spacing(1, 3),
        position: 'relative',
        [theme.breakpoints.only('xs')]: {
            gap: theme.spacing(2),
            gridTemplateColumns: "repeat(auto-fill, ".concat(_constants.ITEM_WIDTH_XS, "px)"),
            padding: theme.spacing(0, 2)
        },
        [theme.breakpoints.down(_constants.XXS)]: {
            gap: theme.spacing(2),
            gridTemplateColumns: "repeat(auto-fill, ".concat(_constants.ITEM_WIDTH_XXS, "px)"),
            padding: theme.spacing(0, 1)
        }
    });
exports.gridStyles = gridStyles;
const itemStyles = (isDoubleCurrency, theme)=>({
        background: theme.palette.common.white,
        border: "1px solid ".concat(theme.palette.grey[200]),
        borderRadius: theme.spacing(2),
        boxShadow: "0 0 8px ".concat(theme.palette.grey.A100),
        boxSizing: 'border-box',
        height: _constants.ITEM_HEIGHT,
        marginTop: 0,
        position: 'relative',
        width: _constants.ITEM_WIDTH,
        ...isDoubleCurrency && {
            height: _constants.ITEM_HEIGHT + _constants.DOUBLE_CURRENCY_HEIGHT_EXTENSION
        },
        [theme.breakpoints.only('xs')]: {
            height: _constants.ITEM_HEIGHT_XS,
            width: _constants.ITEM_WIDTH_XS,
            ...isDoubleCurrency && {
                height: _constants.ITEM_HEIGHT_XS + _constants.DOUBLE_CURRENCY_HEIGHT_EXTENSION
            }
        },
        [theme.breakpoints.down(_constants.XXS)]: {
            height: _constants.ITEM_HEIGHT_XXS,
            width: _constants.ITEM_WIDTH_XXS,
            ...isDoubleCurrency && {
                height: _constants.ITEM_HEIGHT_XXS + _constants.DOUBLE_CURRENCY_HEIGHT_EXTENSION
            }
        }
    });
exports.itemStyles = itemStyles;
const imageStyles = (theme)=>({
        borderRadius: theme.spacing(2, 2, 0, 0),
        height: _constants.ITEM_WIDTH,
        overflow: 'hidden',
        position: 'relative',
        [theme.breakpoints.only('xs')]: {
            height: _constants.ITEM_WIDTH_XS
        },
        [theme.breakpoints.down(_constants.XXS)]: {
            height: _constants.ITEM_WIDTH_XXS
        }
    });
exports.imageStyles = imageStyles;
